var React = require('react');

function IcCalendarPlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 2H16C17.1 2 18 2.9 18 4V18C18 19.1 17.1 20 16 20H2C0.9 20 0 19.1 0 18V4C0 2.9 0.9 2 2 2H3V0H5V2H13V0H15V2ZM2 18H16V8H2V18ZM2 6V4H16V6H2ZM9.62131 16.4792H8.37958V13.6209H5.52126V12.3791H8.37958V9.52081H9.62131V12.3791H12.4796V13.6209H9.62131V16.4792Z","fill":"currentColor"}));
}

IcCalendarPlus.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"};

module.exports = IcCalendarPlus;

IcCalendarPlus.default = IcCalendarPlus;
